<script setup>
  defineProps({
    items: {
      type: Array,
      required: true,
    },
  });
</script>

<template>
  <ul class="list-disc pl-6">
    <li v-for="(item, index) in items" :key="index">{{ item }}</li>
  </ul>
</template>
